module.exports = __webpack_public_path__ + "static/media/logo-white.b7f7dd23.png";